module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABDklEQVQ4T62U0WrCMBSGe1KjKAxh1StnLwX3LiKV5jF8I9+g6vBlHHg5hzdtBypMNEvOSDVQo251y7kL/Hz5z3+SAwljc0TsOv8oAHiFOAzRQdwSxOeS637ew/sSoiYB5g7AQwYiUra96fT9HojWpoPBkyRkmYHKAF49ij7+Aloz9nhATI+tWSi7jqy1ZoISxl5AiKE5gLTfb0tKF83xuKrTOMvIBK16vQatVOL8NE+QN8K5781my0IgJcrDHCFAUnoBUbofHenbNEydTSeFHSmhbicD3Xi0vzrKZ7KXcmdmVsjRtWA3QeDtXTc5cO63ioYdh+GOcN7JT0c5yGCEjJqTSXDVkbVPa2WN2Fps3wkPFxokamodAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/dzy/assets/img/rejectD.png
// module id = bP6i
// module chunks = 43